import { Catalog } from "./types/Catalog";
import { SceneResponse } from "./types/Scene";

//export const CONFIGURATOR_API_URL = "http://localhost:7990/api";
export const CONFIGURATOR_API_URL = "https://api.sugartech.io/api";

//export const CONFIGURATOR_CDN_URL = "http://localhost:7980/api";
export const CONFIGURATOR_CDN_URL = "https://cdn.sugartech.io/api";

//export const CONFIGURATOR_API_URL = "http://localhost:7990/api";

export const API_URL = "https://api.sugartech.io/api/dynamicTag/2/source2";

const SCENE_EP = "https://cdn.sugartech.io/api/planner";
// const SCENE_EP = "http://localhost:7980/api/planner";

const AUTH = "Basic " + btoa("planner.default@sugartech.io:planner");

export class Api {
  static async fetchCatalog(identifier: string): Promise<Catalog> {
    let data = await fetch(
      CONFIGURATOR_CDN_URL + "/configurator/" + identifier,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return await (data as any).json();
  }

  static async fetchCatalogProduct(identifier: string): Promise<any> {
    let data = await fetch(
      CONFIGURATOR_API_URL + "/configurator/product/" + identifier,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return await (data as any).json();
  }

  static async fetchProduct(productId: number, companyId: number) {
    let data = await fetch(
      API_URL +
        "?" +
        "sugarProductId=" +
        productId +
        "&" +
        "companyId=" +
        companyId +
        "&" +
        "withFeature=false",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return await (data as any).json();
  }

  static async fetchHDRS(appId: string) {
    let data = await fetch("https://cdn.sugartech.io/api/planner/get-hdrs", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return await (data as any).json();
  }

  static async fetchCustomerProduct(customerId: number, companyId: number) {
    let data = await fetch(
      API_URL +
        "?" +
        "productId=" +
        customerId +
        "&" +
        "companyId=" +
        companyId,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return await (data as any).json();
  }

  static async uploadScene(scene: any) {
    let data = await fetch(SCENE_EP + "/save-scene", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: AUTH,
      },
      body: JSON.stringify(scene),
    });

    return await (data as any).json();
  }

  static async fetchScene(inAppId: number) {
    let response = await fetch(SCENE_EP + "/get-scene?inAppId=" + inAppId, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: AUTH,
      },
    });

    const data: SceneResponse = await (response as any).json();
    data.scene = await fetch(data.fileUrl).then((res) => res.json());
    return data;
  }

  static async fetchAllScenes() {
    let data = await fetch(SCENE_EP + "/list-scene", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: AUTH,
      },
    });

    return await (data as any).json();
  }

  static async fetchConfigurator(id: number) {
    let data = await fetch(CONFIGURATOR_API_URL + "/configurator/zip/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return await (data as any).json();
  }

  static async getProductsOfScene(inAppId: number) {
    return Api.fetchScene(inAppId).then((data) => {
      const scene = data.scene;
      return {
        products: scene?.products,
        productInstances: scene?.productInstances,
      };
    });
  }

  static async getTools(inAppId: number | string | undefined) {
    if (inAppId == "sbalu") {
      return [
        {
          name: "drawer",
          state: "drawer",
          type: "balcony",
          icon: `<svg class="container-svg" data-v-a281fab8-s="">
            <use xlink:href="#glass-wall"></use>
          </svg>`,
        },
      ];
    }
    return [
      {
        name: "drawer",
        state: "drawer",
        type: "wall",
        icon: `<svg class="container-svg" data-v-a281fab8-s="">
          <use xlink:href="#brick-wall"></use>
        </svg>`,
      },
      {
        name: "window",
        state: "window",
        icon: ` <svg class="container-svg" data-v-a281fab8-s="">
          <use xlink:href="#icon-room"></use>
        </svg>`,
      },
      {
        name: "door",
        state: "door",
        icon: ` <svg class="container-svg" data-v-a281fab8-s="">
          <use xlink:href="#glass-wall"></use>
        </svg>`,
      },
    ];
  }

  static async getNavBarConfig(inAppId: number | string | undefined) {
    if (inAppId == "sbalu") {
      return {
        hasNavigation: true,
        panes: [
          {
            title: "drawWall",
            name: "shape-room",
            index: 0,
          },
          {
            title: "addToRoom",
            name: "sbaluproduct",
            index: 1,
          },
          {
            title: "configure",
            name: "wall",
            index: 2,
          },
          {
            title: "export",
            name: "export",
            type: "execute",
            index: 3,
          },
        ],
      };
    }
    return {
      hasNavigation: false,
      panes: [
       
        {
          title: "addToRoom",
          name: "product",
        },

        {
          title: "roomFeatures",
          name: "feat",
        },

        {
          title: "drawWall",
          name: "shape-room",
        },
      ],
    };
  }

  static async saveJoint(body: any) {
    let data = await fetch(CONFIGURATOR_CDN_URL + "/product/model/save/joint", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    return await (data as any).json();
  }

  static async deleteJoint(body: any) {
    let data = await fetch(
      CONFIGURATOR_CDN_URL + "/product/model/delete/joint",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      }
    );

    return await (data as any).text();
  }
}
